import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';
import { Toggle } from 'material-ui';

export const WizToggle = observer(({
  defaultToggled = false,
  toggled,
  label,
  onToggle,
}) => {

  const toggleProps = {
    defaultToggled,
    toggled,
    label,
    onToggle,
  };

  const styles = {
    block: {
      maxWidth: 20,
    }
  };

  return (
    <div >
      <Toggle { ...toggleProps } style={ styles.block }/>
    </div>
  );
});

WizToggle.propTypes = {
  defaultToggled: PropTypes.bool,
  toggled: PropTypes.bool,
  label: PropTypes.node,
  onToggle: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/components/wiz-toggle/wiz-toggle.js